// src/components/header/header.styled.ts
import styled from "@emotion/styled";
import { tablet } from "../../../media";

export const COLORS = {
  accent: "#5E84ED", // -- accent primary
  btnHover: "#2457E3", // -- accent pressed
  link: "#8FB0FF", // -- accent hover/links
  accentGlow: "rgba(94,132,237,0.15)",
  general: "#23252A",
  appBg: "#1A1A1C", // -- neutral canvas
  surface: "#1E1F22", // -- neutral surface
  card: "#26282D", // -- neutral raised
  cardElevated: "#2B2D33", // -- neutral depth
  neutralOverlay: "rgba(255,255,255,0.05)",
  placeholderText: "#595F6C",
  textPrimary: "#E9ECF5", // -- text primary
  textSecondary: "#C5CAD6", // -- text secondary
  textMuted: "#B7BDCB", // -- text muted
  textPlaceholder: "#7D8493", // -- text placeholder
  onPrimary: "#FFFFFF", // -- text/inverse
  danger: "#D65F46", // -- danger
  dangerPressed: "#9E3D2C", // -- pressed (danger pressed)
  success: "#3FCF9B", // -- success
  warning: "#E6B76A", // -- warning
  border: "#2B2D33", // -- border 300
  divider: "#2B2D33", // -- divider 300
  shadowOverlay: "rgba(0,0,0,0.40)", // -- shadow overlay
  scrim50: "rgba(0,0,0,0.50)", // -- scrim 50
  sidebar: "#24262A",
  sidebarBorder: "#2B2D33",
  primaryContainer: "#273258",
  onPrimaryContainer: "#E9ECF5",
  btnRest: "#406CE7",
  btnActive: "#1A49CF",
  btnText: "#FFFFFF",
  btnDisabled: "#2A2A2E",
  outline: "#343844",
  focusRing: "#98B3FF",
};

export const s = (n: number) => `${n * 8}px`;

export const HeaderSpacer = styled.div`
  height: calc(56px + env(safe-area-inset-top, 0px));
  flex-shrink: 0;

  ${tablet`
    height: auto;
  `}
`;

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${s(2)};
  padding: calc(env(safe-area-inset-top, 0px) + 6px) 16px 6px 16px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 60;
  background: ${COLORS.appBg};
  border-top: 0px solid ${COLORS.border};
  border-right: 0px solid ${COLORS.border};
  border-bottom: 1px solid ${COLORS.border};
  border-left: 0px solid ${COLORS.border};

  ${tablet`
    position: sticky;
    left: auto;
    right: auto;
  `}
`;

export const HamburgerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 80ms ease;

  &:active {
    opacity: 0.5;
  }
`;

export const RightActions = styled.div({
  display: "flex",
  alignItems: "center",
  gap: s(2),
  flex: "0 0 auto",
});

export const IconButton = styled.button({
  width: s(4),
  height: s(4),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 10,
  background: "none",
  border: `none`,
  color: COLORS.textSecondary,
  transition:
    "transform 80ms ease, opacity 80ms ease, background 150ms ease, box-shadow 150ms ease",
  cursor: "pointer",
  touchAction: "manipulation",
  WebkitTapHighlightColor: "transparent",
  willChange: "transform",
  "&:hover": { transform: "translateY(-1px)" },
  "&:active": { transform: "scale(0.88)", opacity: 0.7 },
});

// ✅ NEW: Cancel button (replaces RightActions while fullscreen recording)
export const CancelButton = styled.button({
  appearance: "none",
  border: "none",
  background: "transparent",
  padding: `${s(1)} ${s(1)}`,
  cursor: "pointer",
  touchAction: "manipulation",
  WebkitTapHighlightColor: "transparent",

  fontFamily:
    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "140%",
  letterSpacing: "0px",
  textAlign: "center",
  verticalAlign: "middle",
  color: "#B7BDCBCC",

  transition: "opacity 80ms ease, transform 80ms ease",

  "&:hover": {
    opacity: 0.9,
  },
  "&:active": {
    opacity: 0.6,
    transform: "scale(0.94)",
  },
  "&:focus-visible": {
    outline: `2px solid ${COLORS.focusRing}`,
    outlineOffset: 2,
    borderRadius: 10,
  },
});
